module.exports = __webpack_public_path__ + "static/media/icon-cc.5fc9c464.svg";